import React from "react";
import { MSCellDataConstants } from "@pages/managed-accounts/model-screener/constant";
import { CheckSVG, CrossSVG } from "@components/svgs";
import { ModelScreenerCellData } from "@models/model-screener/entities/modelScreenerData";
import { MSTableTextShortCell } from "@pages/managed-accounts/model-screener/components/model-screener-table/rendered-fields/text-short-cell";

export const MSTableYesNoCell = React.memo(
  ({ cellData }: { cellData: ModelScreenerCellData }) => {
    const CellValueComponents: Record<string, JSX.Element> = {
      [MSCellDataConstants.Yes]: <CheckSVG width={"16px"} />,
      [MSCellDataConstants.No]: <CrossSVG width={"16px"} />,
    };
    const renderedComponent = CellValueComponents[cellData.value];

    return renderedComponent ? (
      renderedComponent
    ) : (
      <MSTableTextShortCell cellData={cellData} />
    );
  },
);
